import { makeAutoObservable, runInAction } from 'mobx'
import { CompanyName, DeleteAccount, FullName, User, UserChangePassword } from '../models/User'
import agent from '../api/agent'
import { store } from './store'
import { toast } from 'react-toastify'

export default class ProfileStore {
  constructor() {
    makeAutoObservable(this)
  }

  changeUserPassword = async (currentPass: string, newPass: string) => {
    const pass: UserChangePassword = {
      currentPassword: currentPass,
      password: newPass,
      hasPassword: store.userStore.user?.hasPassword || false,
    }
    await agent.Profile.changePassword(pass).then(() => {
      store.userStore.setUserHasPassword(true)
    })
  }

  changeUserFullName = async (fullName: FullName) => {
    const userData = store.userStore.user as User

    userData.firstName = fullName.firstName
    userData.lastName = fullName.lastName

    await agent.Profile.editUser(userData)
    runInAction(() => {
      store.userStore.getData.firstName = fullName.firstName
      store.userStore.getData.lastName = fullName.lastName
    })
  }

  changeUserCompanyName = async (company: CompanyName) => {
    const userData = store.userStore.user as User

    userData.companyName = company.companyName
    userData.companyUrl = company.companyUrl

    await agent.Profile.editUser(userData)
    runInAction(() => {
      store.userStore.getData.companyName = company.companyName
      store.userStore.getData.companyUrl = company.companyUrl
    })
  }

  changeUserPhoneNumber = async (phoneNumber: string) => {
    const userData = store.userStore.user as User
    userData.phoneNumber = phoneNumber

    await agent.Profile.editUser(userData)
    runInAction(() => {
      store.userStore.getData.phoneNumber = phoneNumber
    })
  }

  changeUserGender = async (gender: number) => {
    const user = store.userStore.user as User
    user.gender = gender
    await agent.Profile.editUser(user)
    runInAction(() => {
      store.userStore.user!.gender = gender
    })
  }

  changeUserAvatar = async (file: Blob) => {
    const formData = new FormData()
    formData.append('File', file)
    const { status, data: photoData } = await agent.Profile.editAvatar(formData)
    if (status === 200) {
      runInAction(() => {
        store.userStore.user!.avatar = photoData.url
        store.userStore.user!.avatarId = photoData.publicId
      })
    }
  }

  deleteAccount = async (data: DeleteAccount) => {
    const { status, data: user } = await agent.Profile.deleteAccount(data)
    if (status === 200) {
      store.userStore.logout()
      toast.success('Account has been deleted Successfully')
    }
  }
}
